import { useState, useEffect } from "react";

import Tabs from "../tab/Tabs.jsx";
import InventoryTab from "./InventoryTab.jsx";
import BillsTab from "./BillsTab.jsx";
import useAxios from "../../services/useAxios.tsx";
export default function StorageTab({
  users,
  billContent,
  inventoryContent,
  setUpdater
}) {
  // const { execute: storeHouse } = useAxios("api2/storehouse");

  // const [inventoryContent, setInventoryContent] = useState([]);
  // const [billContent, setBillContent] = useState([]);

  // useEffect(() => {
  //   storeHouse().then(data => {
  //     setInventoryContent(data.whiteHouseItem);
  //     setBillContent(data.checkInOut);

  //   });
  // }, []);
  const [nav, setNav] = useState([
    { title: "لیست محصولات", target: "navs-pill-productStorage" },
    { title: "قبض های انبار", target: "navs-pill-billStorage" }
  ]);
  const [tab, setTab] = useState([]);
  useEffect(() => {
    setTab([
      {
        id: "navs-pill-productStorage",
        component: (
          <InventoryTab
            users={users}
            content={inventoryContent}
            setUpdater={setUpdater}
            // setContent={setInventoryContent}
          />
        )
      },
      {
        id: "navs-pill-billStorage",
        component: (
          <BillsTab
            users={users}
            content={billContent}
            setUpdater={setUpdater}
            // setContent={setBillContent}
          />
        )
      }
    ]);
  }, [users, billContent, inventoryContent]);
  return (
    <>
      <div>
        <Tabs navItem={nav} tabContent={tab} type="horiz" />
      </div>
    </>
  );
}
